import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const TejaxoCloudBasedERP = ({ location }) => {
  //useEffect(() => {
  //  document.title = `Cloud Based ERP Software ${location} | Cloud Based ERP Systems ${location} | Business Management Solutions - Tejaxo Software`;
  //  document.querySelector('meta[name="description"]').setAttribute(
  //    'content',
  //    `Tejaxo Software is a High Rated Cloud Based Indian ERP and BI software development company, providing award-winning Enterprise Resource Planning (ERP) software on Cloud ${location}, business management solutions, services and support.`
  //  );
  //  document.querySelector('meta[name="keywords"]').setAttribute(
  //    'content',
  //    'Tejaxo Software, Tejaxo ERP, ERP Cloud Based Software, Tejaxo BI, School ERP Cloud Based, School Software Cloud Based'
  //  );
  //}, [location]);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
    <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 content">
            <h2 className="elementor-heading-title elementor-size-default">
              When buying an ERP to run your growing business�
            </h2>
            <p>
              �you typically face a choice between entry level packages that fall short in capability and enterprise solutions that can be a harder investment to justify. Compromising on features can however cost you a lot in the long term. Duplicated and manual processes create errors � and productivity sapping inefficiencies are left to multiply. Even more frustratingly, once your business grows, you will need to make an arduous switch to a new enterprise solution, forcing your staff to learn new processes again.
            </p>
          </div>
          <div className="col-lg-6 about-img">
            <img src="/theme/img/Tejaxo-ready-cloud-erp-1-1-768x512.jpg" alt="Cloud ERP" />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-lg-6 about-img">
            <img src="/theme/img/bdimg10.JPG" alt="ERP Benefits" />
          </div>
          <div className="col-lg-6 content">
            <h2 className="elementor-heading-title elementor-size-default">
              With over 1,700 customers � many of who started small, we decided we needed to build a solution to this challenge.
            </h2>
            <p>
              We blueprinted Tejaxo Xi enterprise ERP for specific industries, reducing the implementation effort significantly. This allowed us to create a more affordable, scalable ERP software with the depth of functionality your business needs now � and the foundation to switch to Tejaxo Xi enterprise ERP seamlessly, when your growth demands more. To make this even easier for you, Tejaxo Ready applications are delivered by Tejaxo Cloud, reducing your IT infrastructure and skill requirements to a minimum.
            </p>
          </div>
        </div>
      </div>
            </section>
        </MasterPage>
  );
};

export default TejaxoCloudBasedERP;
